import styled from 'styled-components';

const PageWrapper = styled.div`
  width: 100%;
  overflow-x: hidden; //some shapes are overflowing outside visible body
`;

export default PageWrapper;
